<template>
  <div class="trainIndex">
    <Header title="课程设置总表" type="0" route="/train/index?type=0"></Header>
    <div class="train">
      <div class="list-head">
        <p>{{ detailList.courseName }}</p>
        <van-row>
          <van-col span="12">
            <ul>
              <li>总学时：{{ detailList.totalHours }}</li>
              <li>课程编号：{{ detailList.courseCode }}</li>
            </ul>
          </van-col>
          <van-col span="12">
            <ul>
              <li>学分：{{ detailList.credit }}</li>
              <li>考核方式：{{ detailList.evaluationMode }}</li>
            </ul>
          </van-col>
        </van-row>
      </div>
      <van-field
        v-model="detailList.whetherTest"
        label="是否考试"
        readonly
        input-align="right"
      />
      <van-field
        v-model="detailList.courseAttribute"
        label="课程属性"
        readonly
        input-align="right"
      />
      <van-field
        v-model="detailList.openSemester"
        type="number"
        label="开设学期"
        readonly
        input-align="right"
      />
      <van-field
        v-model="detailList.courseUnits"
        label="开课单位"
        readonly
        input-align="right"
      />
      <van-field
        v-if="detailList.classHourClassification"
        v-model="detailList.classHourClassification[0].classHour"
        type="number"
        :label="detailList.classHourClassification[0].name"
        readonly
        input-align="right"
      />
      <van-field
        v-if="detailList.classHourClassification"
        v-model="detailList.classHourClassification[1].classHour"
        type="number"
        :label="detailList.classHourClassification[1].name"
        readonly
        input-align="right"
      />
      <van-field
        v-if="detailList.classHourClassification"
        v-model="detailList.classHourClassification[2].classHour"
        type="number"
        :label="detailList.classHourClassification[2].name"
        readonly
        input-align="right"
      />
      <van-field
        v-if="detailList.classHourClassification"
        v-model="detailList.classHourClassification[3].classHour"
        type="number"
        :label="detailList.classHourClassification[3].name"
        readonly
        input-align="right"
      />
    </div>
  </div>
</template>

<script>
import { Api } from "../../../../utils/axios";
export default {
  data() {
    return { detailList: [], courseUnits: "" };
  },
  created() {
    this.detailList = this.$route.query.list;
  }
};
</script>
<style lang="less" scoped>
.trainIndex .train {
  padding: 5% 5% 0;
  .list-head {
    background-image: url("../../../../../static/image/head.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    padding: 6% 7%;
    box-sizing: border-box;
    margin-bottom: 5%;
    position: relative;
    flex-direction: column;
    p {
      height: 22px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #fff;
      letter-spacing: 0;
      margin-bottom: 2%;
      font-weight: bold;
    }
    ul li {
      height: 17px;
      font-family: PingFangSC-Light;
      font-size: 12px;
      color: #fff;
      letter-spacing: 0;
      margin-bottom: 1%;
      font-weight: lighter;
    }
    span {
      position: absolute;
      top: 15%;
      right: 7%;
      color: #fff;
      border-radius: 40%;
      font-size: 14px;
      padding: 1% 3%;
      background-color: #8f87f9;
    }
  }

  .van-cell {
    padding: 10px 0;
    border-bottom: 1px solid #f4f4f4;
  }
  .van-cell::after {
    display: none;
  }
  .van-field__label {
    width: 7.2em;
  }
  .van-cell.van-field .van-cell__title.van-field__label > span {
    font-family: PingFangSC-Light;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
  }
  .van-field__control::-webkit-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    letter-spacing: 0;
    font-weight: normal;
    text-align: right;
  }
  .van-field__control::-moz-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    font-weight: normal;
    letter-spacing: 0;
    text-align: right;
  }
  .van-field__control::-ms-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    letter-spacing: 0;
    font-weight: normal;
    text-align: right;
  }
  .van-field__control {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
    text-align: right;
    font-weight: bolder;
  }
  .van-icon-arrow {
    color: #dfe0e6;
    font-weight: bolder;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/train/item.vue